export default __webpack_public_path__ + "static/media/renew-code--mobile@4x.aeb1b4b2.jpg";